import React, { useMemo } from 'react';

import StatCard from '../../common/StatCard/StatCard';

import usePrometheusQuery from '../../../utils/hooks/use_prometheus_query_without_range';
import { percentFormatter } from '../../../utils/formatters';
import { valueFormatter } from '../../../utils/prometheus_utils';
import { CPUIcon } from '../../common/icons/CPUIcon';
import Icon from '../../common/icons/Icon';
import COLORS from '../../../constants/colors.constants';

const getRequestedCPUQuery = () => {
  return 'sum(wallaroo_kube_pod_resource_requests{resource="cpu"})';
}

const getTotalCPUQuery = () => {
  return 'sum(kube_node_status_capacity{resource="cpu"})';
}

const CPUIconComponent = () => {
  return <Icon fill={COLORS.brand} icon={CPUIcon} size={24} useTailwindSizing />
}

export const useTotalCPU = () => {
  const query = useMemo(() => {
    return getTotalCPUQuery();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const useRequestedCPU = () => {
  const query = useMemo(() => {
    return getRequestedCPUQuery();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const ContextualTotalCPUCard = () => {
  const requestedResponse = useRequestedCPU()
  const requestedData = requestedResponse?.chartData;
  const requestedValue = requestedData?.length ? requestedData[1] : 0;

  const totalResponse = useTotalCPU()
  const totalData = totalResponse?.chartData;
  const totalValue = totalData?.length ? totalData[1] : 0;

  const subtitle = `Requested ${valueFormatter.format(requestedValue)}/${valueFormatter.format(totalValue)} CPUs Allocated`;

  const content = totalValue ? percentFormatter.format(requestedValue / totalValue) : totalValue;

  const isLoading = requestedResponse?.isLoading || totalResponse?.isLoading;

  return (
    <StatCard
      className=""
      icon={CPUIconComponent}
      header="Total CPU Currently Requested"
      subtitle={subtitle}
      content={`${content}`}
      isLoading={isLoading}
    />
  )
}

export default ContextualTotalCPUCard;
